<template>
  <div>
    <div :class="is_mobile_app ? '' : 'wrapper'">
      <section class="mb-5 pt-3" v-if="false">
        <h4>Hola!</h4>
        <p>
          Your search for a perfect online movie ticket booking app just got
          over.
          <span v-if="project == 'wanasatime'">MyTiketi- Kenya’s</span>
          <span v-if="project == 'ticketak'">Ticketak UAE's</span> first online
          movie ticket aggregator Platform is now available on the web & app
          stores.
        </p>

        <p>
          We are going to change the way you book your movie tickets online.
          It’s going to be as simple as App- Tap- Book.
        </p>

        <p>
          Surf through multiple movies & cinemas near you and book your movie
          tickets on the go!
        </p>
        <h4 class="text-center mb-4 mt-3">
          How to book a movie ticket on
          <span v-if="project == 'wanasatime'">MyTiketi</span>
          <span v-if="project == 'ticketak'">Ticketak</span>?
        </h4>
        <div class="step-wrapper">
          <div class="single-step">
            <img
              v-if="project == 'ticketak'"
              src="@/assets/img/about/step-1-new.jpg"
              class="w-75 border rounded"
              alt
            />
            <img
              v-else
              src="@/assets/img/about/trailer.jpg"
              class="w-75 border rounded"
              alt
            />
            <p class="h5 mt-2">Watch Movie Trailers</p>
          </div>

          <div class="single-step">
            <img
              v-if="project == 'ticketak'"
              src="@/assets/img/about/step-5.jpeg"
              class="w-75 border rounded"
              alt
            />
            <img
              v-else
              src="@/assets/img/about/Cinemas.jpg"
              class="w-75 border rounded"
              alt
            />
            <p class="h5 mt-2">Check Cinemas Near You</p>
          </div>

          <div class="single-step">
            <!-- step-3-myticketi.jpg -->
            <img
              v-if="project == 'ticketak'"
              src="@/assets/img/about/step-4.jpeg"
              class="w-75 border rounded"
              alt
            />
            <img
              v-else
              src="@/assets/img/about/showtime.jpg"
              class="w-75 border rounded"
              alt
            />
            <p class="h5 mt-2">Check Show Timings</p>
          </div>

          <div class="single-step">
            <!-- step-4-myticketi.jpg -->
            <img
              v-if="project == 'ticketak'"
              src="@/assets/img/about/step-3.jpeg"
              class="w-75 border rounded"
              alt
            />
            <img
              v-else
              src="@/assets/img/about/Seat_Layout.jpg"
              class="w-75 border rounded"
              alt
            />
            <p class="h5 mt-2">Choose Your Seats</p>
          </div>

          <div class="single-step">
            <!-- step-5-myticketi.jpg -->
            <img
              v-if="project == 'ticketak'"
              src="@/assets/img/about/step-2.jpeg"
              class="w-75 border rounded"
              alt
            />
            <img
              v-else
              src="@/assets/img/about/Booking_Summary.jpg"
              class="w-75 border rounded"
              alt
            />
            <p class="h5 mt-2">& Book Movie Tickets!</p>
          </div>
        </div>
      </section>

      <section v-if="false">
        <h4 class="text-center">
          Why use
          <span v-if="project == 'wanasatime'">MyTiketi</span>
          <span v-if="project == 'ticketak'">Ticketak</span>?
        </h4>
        <div class="row">
          <div class="col-12 col-md-3 text-center">
            <p>
              online movie ticket aggregator in The
              <span v-if="project == 'wanasatime'">Kenya</span>
              <span v-if="project == 'ticketak'">UAE</span>
            </p>
          </div>
          <div class="col-12 col-md-3 text-center">
            <p>Browse through multiple cinemas at once</p>
          </div>
          <div class="col-12 col-md-3 text-center">
            <p>Real-time seat selection</p>
          </div>
          <div class="col-12 col-md-3 text-center">
            <p>Booking movie tickets on the go</p>
          </div>
        </div>
      </section>

      <!--New Design-->
      <section class="row back_white mb-3" :class="isRTL ? 'rtl' : ''">
        <div class="col-12 d-flex justify-content-center">
          <h3 class="static_title">{{ $t("ABOUT") }}</h3>
        </div>
        <div class="col-12">
          <p class="mb-2">{{ $t("WANASATIME_ENTERTAINMENT") }}</p>
        </div>

        <div class="col-12">
          <p class="mb-2">
            {{ $t("SCREENS_PARTNERS") }}
          </p>
        </div>

        <!-- <div class="col-12">
          <p class="mb-2">
            {{ $t("EVENT_CATEGORIES") }}
          </p>
        </div> -->

        <div class="col-12 mt-4">
          <div class="row">
            <div
              class="col-xl-4 col-md-12 col-lg-6 col-sm-12 col-xs-12 acheivments_info"
            >
              <span class="title_no">12+</span>
              <h6 class="text-capitalize">{{ $t("YEARS_IN_TICKETING") }}</h6>
            </div>

            <div
              class="col-xl-4 col-md-12 col-lg-6 col-sm-12 col-xs-12 acheivments_info"
            >
              <span class="title_no">15+</span>
              <h6 class="text-capitalize">{{ $t("YEARS_OF_GCC_PRESENCE") }}</h6>
            </div>

            <div
              class="col-xl-4 col-md-12 col-lg-6 col-sm-12 col-xs-12 acheivments_info"
            >
              <span class="title_no">5+</span>
              <h6 class="text-capitalize">{{ $t("MILLION_TICKETS_SOLD") }}</h6>
            </div>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center mt-5">
          <h3 class="static_title_next">{{ $t("HOW_WANASATIME_WORKS") }}</h3>
        </div>
        <div class="col-12">
          <p>{{ $t("WANASATIME_TRANSACTION_M-TICKETS") }}.</p>
        </div>

        <div class="col-12 mt-4">
          <div class="row">
            <div
              class="col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-flex"
              :class="isRTL ? 'center_md' : ''"
            >
              <img src="@/assets/img/Ab1.png" class="about_img" />
              <div class="d-block" :class="isRTL ? 'mr-3' : ' ml-3'">
                <h4>{{ $t("FREE_RESGIDTRATION") }}</h4>
                <span class="about_des">{{ $t("EVENT_PLANNER") }}</span>
              </div>
            </div>

            <div
              class="col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-flex"
              :class="isRTL ? 'center_md' : ''"
            >
              <img src="@/assets/img/Ab2.png" class="about_img" />
              <div class="d-block" :class="isRTL ? 'mr-3' : 'ml-3'">
                <h4>{{ $t("MULTIPLE_USER-ACCESS") }}</h4>
                <span class="about_des">{{ $t("PROVIDES_ACCESS") }}</span>
              </div>
            </div>

            <div
              class="col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-flex"
              :class="isRTL ? 'center_md' : ''"
            >
              <img src="@/assets/img/Ab3.png" class="about_img" />
              <div class="d-block" :class="isRTL ? 'mr-3' : 'ml-3'">
                <h4>{{ $t("RESERVED_SEATING") }}</h4>
                <span class="about_des">{{ $t("ATTENDEES_EVENT_SEATS") }}</span>
              </div>
            </div>

            <div
              class="col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-none"
              :class="isRTL ? 'center_md' : ''"
            >
              <img src="@/assets/img/Ab4.png" class="about_img" />
              <div class="d-block" :class="isRTL ? 'mr-3' : ' ml-3'">
                <h4>{{ $t("IVITES_REMINDERS") }}</h4>
                <span class="about_des">{{ $t("SEND_RECEIVE") }}</span>
              </div>
            </div>

            <div
              class="col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-none"
              :class="isRTL ? 'center_md' : ''"
            >
              <img src="@/assets/img/Ab5.png" class="about_img" />
              <div class="d-block" :class="isRTL ? 'mr-3' : ' ml-3'">
                <h4>{{ $t("CUSTOM_EVENT") }}</h4>
                <span class="about_des">{{ $t("HOST_CAN_CREATE") }}</span>
              </div>
            </div>

            <div
              class="col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-none"
              :class="isRTL ? 'center_md' : ''"
            >
              <img src="@/assets/img/Ab6.png" class="about_img" />
              <div class="d-block " :class="isRTL ? 'mr-3' : ' ml-3'">
                <h4>{{ $t("PERSONALIZE_EVENT") }}</h4>
                <span class="about_des">{{ $t("CUSTOMIZE_EVENT") }}</span>
              </div>
            </div>

            <div
              class="col-xl-6 col-xs-12 col-sm-12 col-md-12 col-lg-6 mb-4 d-flex"
              :class="isRTL ? 'center_md' : ''"
            >
              <img src="@/assets/img/Ab7.png" class="about_img" />
              <div class="d-block" :class="isRTL ? 'mr-3' : ' ml-3'">
                <h4>{{ $t("REPARTING_DASHBOARD") }}</h4>
                <span class="about_des">{{ $t("ACCESS_DETAILED") }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!--New Design Ends-->
    </div>
  </div>
</template>

<script>
import {
  PROJECT,
  METAWEBSITE,
  METAORGANIZATION,
  metaInfo
} from "@/helper/constant.js";
import { mapGetters } from "vuex";
export default {
  metaInfo: metaInfo,
  project: PROJECT,
  data() {
    return {
      project: PROJECT,
      metaWebsite: METAWEBSITE,
      metaOrganization: METAORGANIZATION,
      is_mobile_app: 0
    };
  },
  watch: {
    "$route.query": {
      handler(newVal, oldVal) {
        console.log({ newVal: { ...newVal }, oldVal: { ...oldVal } });
        const is_mobile_app = parseInt(newVal.is_mobile_app) || 0;

        this.$nextTick(() => {
          if (!!is_mobile_app) {
            this.is_mobile_app = is_mobile_app;
          }
        });
      },
      immediate: true
    }
  },
  mounted() {
    metaInfo.title =
      "About us - Cineco | Movie and Event Ticketing Platform in Bahrain";
    metaInfo.meta[2].content =
      "Cineco - Your one stop online ticketing platform for movies and events near you in Bahrain";
    metaInfo.meta[3].content = "About us, cineco";
  },
  computed: {
    ...mapGetters(["isRTL"])
  }
};
</script>
<style>
.step-container {
  width: 100%;
  display: flex;
}

.step-container .single-step {
  padding: 10px;
  width: calc(100% / 5);
}

/* .arrow {
    height: 100%;
    display: flex;
    align-items: center;
    padding-top: 180px;
    justify-content: center;
  } */

.step-wrapper {
  display: flex;
}

.step-wrapper .single-step {
  text-align: center;
  padding-left: 15px;
  padding-right: 15px;
  width: calc(100% / 5);
}

@media (max-width: 767px) {
  .step-wrapper {
    flex-wrap: wrap;
    justify-content: center;
  }

  .step-wrapper .single-step {
    margin-bottom: 35px;
    width: calc(100% / 2);
  }
}

@media (max-width: 576px) {
  .step-wrapper .single-step {
    width: 100%;
  }
}

/* sdas */
</style>



// WEBPACK FOOTER //
// src/components/pages/aboutUs.vue